import React, {useEffect, useState} from 'react';
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Button} from "@material-ui/core";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";


const useStyles = makeStyles((theme)=>({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #dbe2ea',
        borderRadius: 12,
        boxShadow: theme.shadows[8],
        padding: theme.spacing(3),
        width: '420px',
        maxWidth: '92vw',
        height: 'auto',
        overflowY: 'auto',
        overflowX: 'hidden'
    },
    btn: {
        marginTop: 12,
        height: 40,
        textTransform: 'none',
        fontWeight: 600
    },
    actionRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(1.5),
    },
    closeBtn: {
        backgroundColor: '#eef2f7',
        color: '#203040',
    },
    deleteBtn: {
        backgroundColor: '#d32f2f',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#b71c1c',
        }
    },
    message: {
        color: '#415466',
        marginTop: theme.spacing(1),
    },
    warning: {
        color: '#ed6c02',
        marginTop: theme.spacing(1),
        fontSize: '0.9rem',
    },
    deny: {
        color: '#d32f2f',
        marginTop: theme.spacing(1),
        fontSize: '0.9rem',
    },
}));

/** MongoDB ObjectId: 24 hex chars (avoids calling API with -1 / invalid). */
const isValidEntityId = (id) => {
    if (id == null || id === '') return false;
    const s = String(id);
    return /^[a-fA-F0-9]{24}$/.test(s);
};

function PreRemoveModal(props) {

    const { open, t_id, title, deleteAPI, preRemoveAPI, handleClose } = props;

    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [delAllowed, setDelAllowed] = useState(false);
    const [denyMessage, setDenyMessage] = useState('');
    const [warningMessage, setWarningMessage] = useState('');

    useEffect(() => {
        setWarningMessage('');
        setDenyMessage('');
        setDelAllowed(false);
        if (!open) return;
        if (!isValidEntityId(t_id)) return;
        preCheckServiceCall().then(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, t_id]);

    const preCheckServiceCall = async () => {
        setWarningMessage('');
        setDenyMessage('');
        if (isValidEntityId(t_id)) {
            setLoading(true);
            try {
                const res = await preRemoveAPI(t_id);
                if (!res.deny) {
                    setDelAllowed(true);
                } else {
                    setDelAllowed(false);
                    setDenyMessage(res.deny_message);
                }

                if (res.warning) {
                    setWarningMessage(res.warning_message)
                }

                setLoading(false);
            } catch (e) {
                // error toasted already
                setLoading(false);
            }
        }
    }

    return (

        <>
            <LoaderWithBackDrop loading={loading} />
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.modalPaper}>

                        <h2 id="transition-modal-title">{title}</h2>
                        <p className={classes.message}>Are you sure you want to remove this record?</p>
                        {warningMessage ? <p className={classes.warning}>{warningMessage}</p> : null}
                        {!delAllowed && denyMessage ? <p className={classes.deny}>{denyMessage}</p> : null}

                        <div className={classes.actionRow}>
                            <Button
                                variant="contained"
                                className={`${classes.btn} ${classes.closeBtn}`}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            {
                                delAllowed && <Button
                                    variant="contained"
                                    className={`${classes.btn} ${classes.deleteBtn}`}
                                    onClick={()=>deleteAPI(t_id)}
                                >
                                    Delete
                                </Button>
                            }
                        </div>

                    </div>
                </Fade>
            </Modal>
        </>
    );
}

export default PreRemoveModal;